// ========== 合同签署状态管理 ==========

let _showFn = null

export const contractState = {
  signed: true
}

export function onContractPopup(fn) { _showFn = fn }
export function showContractPopup() { if (_showFn) _showFn() }
export function resetContractState() {
  contractState.signed = true
}
